import {isNil} from '../../helpers'

export default class ProductImageGallery {
    constructor(_root) {
        this._root = _root
        this._canvas = this._root.querySelector('.product-header-image--canvas')
        this._imageButtons = Array.from(this._root.querySelectorAll('button.switch-image'))
        this._initialize()
        this._setupEventListeners()
    }

    _initialize() {}

    _setupEventListeners() {
        this._imageButtons.forEach(_imageButton => {
            _imageButton.addEventListener('click', this._selectImage.bind(this))
        });
    }

    _selectImage(_event) {
        const imageButton = _event.currentTarget;
        const imageData = imageButton.getAttribute('data-imagedata')

        if (isNil(imageButton) || isNil(imageData)) {
            return false;
        }

        this._unselectOtherImageButtons()
        this._selectButton(imageButton)
        this._changeCanvasImage(JSON.parse(imageData))
    }

    _selectButton(trigger) {
        if (isNil(trigger)) {
            return false;
        }
        trigger.setAttribute('aria-selected', true)
        trigger.classList.toggle('selected')
    }

    _deselectButton(trigger) {
        if (isNil(trigger)) {
            return false;
        }
        trigger.removeAttribute('aria-selected')
        trigger.classList.remove('selected')
    }

    _unselectOtherImageButtons() {
        this._imageButtons.forEach(_imageButton => {
            this._deselectButton(_imageButton)
        });
    }

    _changeCanvasImage(imageData) {
        const canvasImage = this._canvas.querySelector('img.header__image')
        if (isNil(canvasImage)) {
            return false;
        }

        canvasImage.classList.remove('lazyloaded')
        canvasImage.classList.add('lazyload')
        canvasImage.setAttribute('alt', imageData['alternativeText'])
        canvasImage.setAttribute('title', imageData['title'])
        canvasImage.setAttribute('data-name', imageData['name'])
        canvasImage.setAttribute('data-type', imageData['type'])
        canvasImage.setAttribute('height', imageData['height'])
        canvasImage.setAttribute('width', imageData['width'])
        canvasImage.setAttribute('srcset', imageData['sourceSet'])
    }

}



// WEBPACK FOOTER //
// ./Private/Scripts/components/product/ImageGallery.js